import { useIntl } from 'react-intl'
import styled from 'styled-components'

import IslandModal, {
  IslandModalProps
} from 'shared/components/modals/IslandModal'
import { ButtonIntents } from 'shared/ui/Button'
import Flex from 'shared/ui/Flex'
import ModalButton from 'shared/ui/ModalButton'

const Description = styled.p`
  color: ${({ theme }) => theme.color.base.c5};
  text-align: center;
`

type ConfirmBackgroundDeleteModalProps = Pick<
  IslandModalProps,
  'isOpen' | 'closeModal'
> & {
  onConfirm: () => void
}

const ConfirmBackgroundDeleteModal: React.FC<
  ConfirmBackgroundDeleteModalProps
> = ({ isOpen, closeModal, onConfirm }) => {
  const { formatMessage } = useIntl()

  const handleConfirm = () => {
    closeModal()
    onConfirm()
  }

  return (
    <IslandModal
      isOpen={isOpen}
      closeModal={closeModal}
      width={345}
      title={formatMessage({
        id: 'Project.backgrounds.uploads.delete.modal.title'
      })}
    >
      <Description>
        {formatMessage({
          id: 'Project.backgrounds.uploads.delete.modal.description'
        })}
      </Description>

      <Flex marginTop={48} columnGap={7}>
        <ModalButton
          labelId="Actions.cancel"
          isFullWidth
          intent={ButtonIntents.neutral}
          onClick={closeModal}
        />
        <ModalButton
          labelId="Project.backgrounds.uploads.delete.modal.confirm"
          intent={ButtonIntents.danger}
          isFullWidth
          onClick={handleConfirm}
        />
      </Flex>
    </IslandModal>
  )
}

export default ConfirmBackgroundDeleteModal
